/**
 * Synthetic data-key a band's `[lo, hi]` tuple is merged under. SSOT:
 * the data-building pass (`CartesianPanel`) and the rendered `<Area>`
 * (`ChartBand`) must agree on this key, so neither side hard-codes the
 * template.
 */
export const bandDataKey = (index: number) => `__band${index}`;
/**
 * Synthetic row key carrying a scatter series' `:z` (bubble-size) channel.
 * SSOT: the data-building pass writes `row[scatterSizeKey(id)]` and the
 * chart's `<ZAxis dataKey={scatterSizeKey(id)}>` reads it back, so the two
 * sides stay in lockstep — exactly like `bandDataKey` for band ranges.
 */
export const scatterSizeKey = (id: string) => `${id}__z`;
